<template>
  <Badge
    @click="$emit('click')"
    @blur="$emit('blur')"
    @focus="$emit('focus')"
  >
    <slot></slot>
    <template v-slot:icon>
      <EditIcon size="small"></EditIcon>
    </template>
  </Badge>
</template>
<script>
import { Badge, EditIcon } from '@mikmak/components';

export default {
  components: {
    Badge,
    EditIcon,
  },
};
</script>
